// ** Third Party Components
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ToastError from './ToastError';
import toast from 'react-hot-toast';

const MySwal = withReactContent(Swal);

const objType = {
  delete: {
    title: 'Estas seguro de eliminar?',
    text: 'No podras deshacer esto!',
    textConfirm: 'Si, eliminar!',
    textCancel: 'Cancelar',
    textSuccessConfirm: 'Eliminado con exito!',
    textSuccessCancel: 'No se elimino nada :)',
    titleSuccess: 'Eliminado!',
    titleCancel: 'Cancelado'
  },
  update: {
    title: 'Estas seguro de actualizar?',
    text: 'No podras deshacer esto!',
    textConfirm: 'Si, actualizar!',
    textCancel: 'Cancelar',
    textSuccessConfirm: 'Actualizado con exito!',
    textSuccessCancel: 'No se actualizo nada :)',
    titleSuccess: 'Actualizado!',
    titleCancel: 'Cancelado'
  },
  inactive: {
    title: 'Estas seguro de inactivar?',
    text: 'No podras deshacer esto!',
    textConfirm: 'Si, inactivar!',
    textCancel: 'Cancelar',
    textSuccessConfirm: 'Inactivado con exito!',
    textSuccessCancel: 'No se inactivo nada :)',
    titleSuccess: 'Inactivado!',
    titleCancel: 'Cancelado'
  },
  active: {
    title: 'Estas seguro de activar?',
    text: 'No podras deshacer esto!',
    textConfirm: 'Si, activar!',
    textCancel: 'Cancelar',
    textSuccessConfirm: 'Activado con exito!',
    textSuccessCancel: 'No se activo nada :)',
    titleSuccess: 'Activado!',
    titleCancel: 'Cancelado'
  },
  duplicate: {
    title: 'Estas seguro de Duplicar?',
    text: 'No podras deshacer esto!',
    textConfirm: 'Si, Duplicar!',
    textCancel: 'Cancelar',
    textSuccessConfirm: 'Duplicado con exito!',
    textSuccessCancel: 'No se activo nada :)',
    titleSuccess: 'Duplicado!',
    titleCancel: 'Cancelado'
  }
};

export const handleErrors = () => {
  return MySwal.fire({
    title: 'Ups!',
    text: 'Algo ocurrio en nuestro lado, no te preocupes vuelve a intentar!',
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  });
};

export const handleConfirmCancel = (type, show, cb) => {
  return MySwal.fire({
    title: objType[type].title,
    text: show ? objType[type].text : '',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: objType[type].textConfirm,
    cancelButtonText: objType[type].textCancel,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger ms-1'
    },
    buttonsStyling: false
  }).then(async function (result) {
    if (result.value) {
      try {
        await cb(true);
        MySwal.fire({
          icon: 'success',
          title: objType[type].titleSuccess,
          text: objType[type].textSuccessConfirm,
          customClass: {
            confirmButton: 'btn btn-success'
          }
        });
      } catch (e) {
        return MySwal.fire({
          title: 'No puedes hacer esto',
          text: '',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        });
      }
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: objType[type].titleCancel,
        text: objType[type].textSuccessCancel,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        }
      });
    }
  });
};

export const handleConfirmDuplicate = (show, cb) => {
  return MySwal.fire({
    title: objType['duplicate'].title,
    text: show ? objType['duplicate'].text : '',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: objType['duplicate'].textConfirm,
    cancelButtonText: objType['duplicate'].textCancel,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger ms-1'
    },
    buttonsStyling: false
  }).then(async function (result) {
    if (result.value) {
      try {
        await cb(true);
        MySwal.fire({
          icon: 'success',
          title: objType['duplicate'].titleSuccess,
          text: objType['duplicate'].textSuccessConfirm,
          customClass: {
            confirmButton: 'btn btn-success'
          }
        });
      } catch (e) {
        return MySwal.fire({
          title: 'No puedes hacer esto',
          text: '',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        });
      }
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      MySwal.fire({
        title: objType['duplicate'].titleCancel,
        text: objType['duplicate'].textSuccessCancel,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success'
        }
      });
    }
  });
};

export const handleError = (e) => {
  const errors = e.graphQLErrors;
  errors?.forEach((error) => {
    const message =
      error?.extensions?.exception?.response?.es ||
      error?.extensions?.response?.message[0];
    toast((t) => <ToastError t={t} message={message} />);
  });
};
